import { Link } from 'react-router-dom';

const features = [
  {
    icon: 'ri-palette-line',
    title: 'カスタマイズ可能なデザイン',
    image: '/image/ec-detail1.jpeg',
    description: [
      'お客様のご要望に沿ったサイトのデザインが可能です。基調とする色や使いたい要素はもちろん、会社のロゴやコンセプトを反映することもできます。',
      'お打ち合わせの中で、サイトイメージ等を丁寧にお伺いし、理想のサイトのご提案に全力を尽くします。\n※各株式会社や個人事業主はお客様にご準備いただいております。',
    ],
  },
  {
    icon: 'ri-download-cloud-line',
    title: 'デジタルコンテンツの販売',
    image: '/image/ec-detail2.jpeg',
    description: [
      '音楽や映像データなどのデジタルコンテンツの販売にも対応できます。大量の手作業の販売もなく、いつでもどこでもECサイトがあなたの代わりに販売してくれます。',
      '販売しているデジタルコンテンツは、購入後・ダウンロード可能になります。購入した直後にダウンロードできるため、お客様のダウンロード可能期間の設定なども可能です。',
    ],
  },
  {
    icon: 'ri-vip-crown-line',
    title: '会員制のECサイトにも対応',
    image: '/image/ec-detail3.jpeg',
    description: [
      '会員機能を付けることができます。ゲストでも購入可能な会員制ECサイトへの一括管理も可能です。',
      'CSVインポートという方法で大量の会員を一括登録することもできます。会員機能と組み合わせることで会員向けにクーポンを発行し、リピーターの増加を見込みます。',
    ],
  },
  {
    icon: 'ri-bank-card-line',
    title: '豊富な決済機能',
    image: '/image/ec-detail4.jpeg',
    description: [
      '代金引換・クレジット決済に加え、PayPal、LINE Payなど様々な決済方法に対応しています。',
      'デジタルコンテンツの場合はクレジット決済のみたいなどの制限も可能です。',
    ],
  },
];

const steps = [
  {
    number: '1',
    title: 'お問い合わせ',
    description: '購入を検討している旨を<link>お問い合わせフォーム</link>よりご連絡ください。\nご要望や特別なご要件についてご確認いたします。',
  },
  {
    number: '2',
    title: 'ヒヤリング',
    description: 'お客様のご要望を詳しくお伺いいたします。\nお客様のニーズに応えられるよう、費用や仕様の見積りのご提案をさせていただきます。\nこの段階でサンプルイメージのご提示、ご確認をお願いすることがあります。\nオンラインでの実施も可能です。',
  },
  {
    number: '3',
    title: 'お見積もり',
    description: 'ヒヤリングの内容を元に見積もりを作成し提出いたします。\n補助金を含め、実質費用はどのくらいになるかをイメージしていただけます。',
  },
  {
    number: '4',
    title: '制作・公開',
    description: '契約後、すぐに制作に取り掛かることができます。\nページの制作後、動作確認・修正を行い、公開となります。\nお客様の方で入力いただく内容については、入力方法のご説明もいたします。\n公開後も方法や手順を学習し、ご自身で更新できるようサポートいたします。',
  },
];

const ECDetailContent = () => {
  const renderStepDescription = (description: string) => {
    return description.split('\n').map((line, i) => {
      if (line.includes('<link>') && line.includes('</link>')) {
        const parts = line.split(/<link>|<\/link>/);
        return (
          <p key={i} className="text-[13px] text-gray-600 leading-relaxed">
            {parts[0]}
            <Link to="/contact" className="text-[#89B56B] underline hover:text-[#5DAA68] transition-colors cursor-pointer">
              {parts[1]}
            </Link>
            {parts[2]}
          </p>
        );
      }
      return <p key={i} className="text-[13px] text-gray-600 leading-relaxed">{line}</p>;
    });
  };

  return (
    <>
      {/* About Section */}
      <section className="py-20 bg-[#F8FBF6]">
        <div className="max-w-5xl mx-auto px-6">
          <div className="text-center mb-12">
            <p className="text-[#5DAA68] text-xs font-semibold tracking-[0.2em] uppercase mb-3 font-['Inter']">
              About
            </p>
            <h4 className="text-2xl md:text-3xl font-bold text-[#89B56B] font-['Noto_Sans_JP']">
              ECサイトについて
            </h4>
          </div>
          <div className="grid md:grid-cols-2 gap-10 items-start">
            <div>
              <div className="rounded-xl overflow-hidden shadow-md mb-5">
                <img
                  src="/image/product1.jpeg"
                  alt="ECサイトについて"
                  title="ECサイト制作・運営サポート"
                  className="w-full h-[320px] object-cover object-top"
                />
              </div>
              <a
                href="http://demo003.msk2.co.jp/"
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="inline-flex items-center gap-2 px-5 py-2.5 bg-[#89B56B] text-white text-sm font-medium rounded-full hover:bg-[#5DAA68] transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-external-link-line"></i>
                実際のECサイトはこちら
              </a>
            </div>
            <div className="space-y-4 text-[13px] text-gray-700 leading-relaxed">
              <p>
                私たちは、どうしたらお客様に心から信頼して頂けるECサイトを作成できるかを模索し、自らECサイトを運営し、お客様と共に立場になろうと考えました。
              </p>
              <p>
                ECサイトの作成から運営まで全てを行っているからこそ、価格と品質のバランスが取れており、自信を持って本当の意味の「ECサイト」をご提案できます。
              </p>
              <p>
                一般的な制作会社のECサイトだけでなく、法人向けの卸売サイトも作成可能です。また、販売可能なものは限りなく幅広く、「音楽ファイル」「動画データ」などのデジタルコンテンツにも対応しています。サイトのデザインにこだわりましても各種の工夫に取り組んでいたします。
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Feature Section */}
      <section className="py-24 bg-white">
        <div className="max-w-5xl mx-auto px-6">
          <div className="text-center mb-14">
            <p className="text-[#5DAA68] text-xs font-semibold tracking-[0.2em] uppercase mb-3 font-['Inter']">
              Feature
            </p>
            <h4 className="text-2xl md:text-3xl font-bold text-[#89B56B] font-['Noto_Sans_JP']">
              ECサイトの特徴
            </h4>
          </div>
          <div className="space-y-10">
            {features.map((feature, index) => (
              <div
                key={index}
                className="group bg-white rounded-2xl shadow-[0_2px_20px_rgba(137,181,107,0.10)] hover:shadow-[0_8px_32px_rgba(137,181,107,0.16)] transition-all duration-400 overflow-hidden flex flex-col md:flex-row"
              >
                <div
                  className={`relative w-full md:w-[360px] h-[240px] md:h-auto shrink-0 overflow-hidden bg-[#F8FBF6] ${
                    index % 2 === 1 ? 'md:order-2' : ''
                  }`}
                >
                  <img
                    src={feature.image}
                    alt={feature.title}
                    title={`${feature.title} - ECサイト制作`}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className={`flex-1 p-8 flex flex-col justify-center ${index % 2 === 1 ? 'md:order-1' : ''}`}>
                  <div className="flex items-center gap-3 mb-5">
                    <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-[#5DAA68]/10">
                      <i className={`${feature.icon} text-lg text-[#5DAA68]`}></i>
                    </div>
                    <h4 className="text-base font-bold text-[#89B56B]">
                      {feature.title}
                    </h4>
                  </div>
                  <div className="space-y-3">
                    {feature.description.map((text, i) => (
                      <p key={i} className="text-[13px] text-gray-600 leading-[1.9]">
                        {text}
                      </p>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Step Section */}
      <section className="py-28 bg-[#F8FBF6] relative overflow-hidden">
        <div className="max-w-5xl mx-auto px-6 lg:px-10 relative">
          <div className="text-center mb-16">
            <p className="text-[#89B56B] text-xs font-semibold tracking-[0.25em] uppercase mb-4 font-['Inter']">
              Step
            </p>
            <h2 className="text-3xl md:text-4xl font-bold text-[#89B56B] font-['Noto_Sans_JP']">
              導入までのステップ
            </h2>
          </div>

          <div className="relative">
            {/* 縦線 */}
            <div className="absolute left-6 top-0 bottom-0 w-px bg-[#89B56B]/20 hidden md:block"></div>

            <div className="space-y-10">
              {steps.map((step, index) => (
                <div key={index} className="flex gap-8 items-start group">
                  {/* ステップ番号（デスクトップ） */}
                  <div className="hidden md:flex flex-col items-center flex-shrink-0">
                    <div className="w-12 h-12 rounded-full bg-[#89B56B] text-white flex items-center justify-center text-sm font-bold font-['Inter'] shadow-[0_4px_16px_rgba(137,181,107,0.3)] relative z-10">
                      {step.number}
                    </div>
                  </div>

                  {/* コンテンツ */}
                  <div className="flex-1 bg-white rounded-xl p-8 group-hover:shadow-[0_4px_24px_rgba(137,181,107,0.1)] transition-all duration-300">
                    <div className="flex items-center gap-3 mb-3">
                      {/* ステップ番号（モバイル） */}
                      <span className="md:hidden w-8 h-8 rounded-full bg-[#89B56B] text-white flex items-center justify-center text-xs font-bold font-['Inter']">
                        {step.number}
                      </span>
                      <span className="text-xs text-[#89B56B] font-semibold tracking-wider bg-[#89B56B]/10 px-3 py-1 rounded-full">
                        STEP {step.number}
                      </span>
                    </div>

                    <h3 className="text-lg font-bold text-[#89B56B] mb-3 font-['Noto_Sans_JP']">
                      {step.title}
                    </h3>

                    <div className="space-y-1.5">
                      {renderStepDescription(step.description)}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* 製品一覧ボタン */}
          <div className="text-center mt-16">
            <Link
              to="/products"
              className="inline-flex items-center gap-2 px-8 py-3.5 bg-[#89B56B] text-white text-sm font-semibold rounded-full hover:bg-[#5DAA68] transition-colors cursor-pointer whitespace-nowrap shadow-[0_4px_16px_rgba(137,181,107,0.3)]"
            >
              製品一覧を見る
            </Link>
          </div>
        </div>
      </section>
    </>
  );
};

export default ECDetailContent;
